'use strict';exports.__esModule = true;var propTypes = ['apartment', 'cottage', 'penthouse', 'garden_apartment'];

var getPropertyTypesValues = function getPropertyTypesValues(translate) {return propTypes.map(function (type) {return {
      value: type,
      label: translate('propertyTypes', type) };});};exports.default =


{ getPropertyTypesValues: getPropertyTypesValues };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ForeignPagePropertiesContainer/helpers.js
// module id = 575
// module chunks = 0